import { z } from 'zod';
import { DataplaneSpecificConfig, modelsConfigVersion, ROIOffset } from '@tig-dpqa-cloud/contract-backend-common';

const detectionConfig = z.object({
  missingTissueMacroOffsets: ROIOffset.describe('Pixel offsets in the macro of the WSI which define the region of interest for missing tissue detection'),
});

export const inferenceRunConfigSchema = z.object({
  modelsConfigVersion: modelsConfigVersion.optional().describe('The version of the models configuration used for this slide scan'),
  detection: detectionConfig,
  supportedScanners: DataplaneSpecificConfig.shape.supportedScanners.describe('The list of supported scanner types for this slide scan. Missing field means all scanner types are supported. Empty list means no scanner types are supported.'),
}).describe('Configuration used for each inference run');

export type InferenceRunConfig = z.infer<typeof inferenceRunConfigSchema>;
